module.exports = __webpack_public_path__ + "media/images/icons/outlined/partition-e62cc9b63bcbf10962cc66793935395e.svg";